import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LegalPolicyContent from '../components/LegalPolicyContent';
import '../styles/PolicyPage.css';

export default function TermsPage({ user }) {
  return (
    <div className="page-shell">
      <Header user={user} showMenu={false} />
      <main className="page-main">
        <section className="policy-page">
          <h1>利用規約 / Terms of Service</h1>
          <p className="policy-lead">
            本サービスの利用規約です。 / These are the terms of service for this service.
          </p>
          <LegalPolicyContent mode="terms" />
        </section>
      </main>
      <Footer />
    </div>
  );
}
